import { render, staticRenderFns } from "./RightSidebar.vue?vue&type=template&id=97b3141a&scoped=true"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"
import style0 from "./RightSidebar.vue?vue&type=style&index=0&id=97b3141a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b3141a",
  null
  
)

export default component.exports